module.exports = __webpack_public_path__ + "img/logo@2x.8400d3a7.png";